export function validRegex(field) {
    const regex = new RegExp(field.getAttribute("data-regex"));
    return regex.test(field.value) ? true : false;
}
